module.exports = __webpack_public_path__ + "static/media/10_1440.2479058b.jpeg";